export const findNodePosition = (doc, node) => {
    let pos = null;
    doc.descendants((child, childPos) => {
        if (child === node) {
            pos = childPos;
        }
    });
    return pos;
};
